import { render, staticRenderFns } from "./serviceInfo.vue?vue&type=template&id=31322644&scoped=true&"
var script = {}
import style0 from "./serviceInfo.vue?vue&type=style&index=0&id=31322644&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31322644",
  null
  
)

export default component.exports